import React from 'react';
import styled from 'styled-components';
import IconButton from '../Buttons/IconButton/IconButton';
import { TString } from '../Response/Utils';

interface Props {
  items: string[];
  onPress?: Function;
  listElement?: number;
  type?: string;
  dataItem?: string;
  changeCursor?;
  className?: string;
  menu?: boolean;
}

const ListBox = styled.div`
  .each-suggestion {
    width: 100%;
    border:none;
    position: relative;
    color: ${(props: any) => {
      return props.foreground;
    }} 

    &:hover:before {
      position: absolute;
      inset: 0;
      content: '';
      left: 0;
      top: 0;
      width: 100%;
      z-index: 1;
      height: 100%;
      background-color: ${(props: any) => {
        return props.foreground + '1a';
      }};
    }

    &.sf-focus:before,&:active:before {
      position: absolute;
      inset: 0;
      content: '';
      left: 0;
      top: 0;
      width: 100%;
      z-index: 1;
      height: 100%;
      background-color: ${(props: any) => {
        return props.foreground + '33';
      }};
    }
  }
`;

const styleVars = getComputedStyle(document.querySelector(':root'));

export function List(props: Props) {
  const [hovered, setHovered] = React.useState(null);
  let background =
    styleVars.getPropertyValue('--inputBackground') ||
    styleVars.getPropertyValue('--usrMsgBackground') ||
    '#ffffff';
  let foreground =
    styleVars.getPropertyValue('--inputBoxColor') ||
    styleVars.getPropertyValue('--usrMsgColor') ||
    '#000000';

  const clickHandler = (data: any) => {
    props.onPress(data);
  };
  const hoverInput = (data, index) => {
    setHovered(data);
    if (props.changeCursor) props.changeCursor('in', index);
  };

  return (
    <ListBox
      {...{ background: background, foreground: foreground }}
      onMouseLeave={() =>
        props.changeCursor ? props.changeCursor('out') : null
      }
      className={`${props.className} styled-scroll ${
        props.type === 'modal' ? 'lang-select-list ' : `sf-suggestion-wrapper `
      } `}
    >
      {props.items.map((data, index) => {
        return (
          <div
            tabIndex={props.type !== 'modal' ? 0 : -1}
            key={index}
            onClick={() =>
              (props.type && props.type === 'auto') || props.type === 'modal'
                ? clickHandler(data)
                : props.onPress(data)
                ? props.onPress(data)
                : null
            }
            className={`${
              props.type !== 'modal'
                ? 'each-suggestion'
                : 'each-suggestion-modal'
            } ${
              props.listElement && props.listElement - 1 === index
                ? 'sf-focus'
                : ''
            } clickable`}
            onMouseOver={() => hoverInput(data, index + 1)}
            onMouseOut={() => setHovered(null)}
          >
            {props.type === 'modal' ? (
              <div className={`radio-icon-div `}>
                {data === props.dataItem ? (
                  <IconButton
                    ariaLabelledBy={data.replace(/\s/g, '_')}
                    variant={'empty'}
                    size="large"
                    fill={styleVars.getPropertyValue('--srvMsgColor')}
                    title={TString({
                      labelName: 'SelectedLabel'
                    })}
                    image={'checkedRadio'}
                    hovered={hovered === data}
                    fullColor
                  />
                ) : (
                  <IconButton
                    ariaLabelledBy={data.replace(/\s/g, '_')}
                    variant={'empty'}
                    size="large"
                    title={TString({
                      labelName: 'unselectedLabel'
                    })}
                    image={'uncheckedRadio'}
                    fill={styleVars.getPropertyValue('--srvMsgColor')}
                    hovered={hovered === data}
                  />
                )}
              </div>
            ) : null}
            <div>{data}</div>
            <span id={data.replace(/\s/g, '_')} hidden>
              {`${
                data === props.dataItem
                  ? TString({
                      labelName: 'SelectedLabel'
                    })
                  : TString({
                      labelName: 'unselectedLabel'
                    })
              } ${data}`}
            </span>
          </div>
        );
      })}
    </ListBox>
  );
}

export default List;
